export default __webpack_public_path__ + "static/media/dashboard_example.ebbc2eaa.png";